import React, { useEffect, useRef, useState } from "react";

// https://stackoverflow.com/questions/53845595/wrong-react-hooks-behaviour-with-event-listener
export function useStateRef<T>(initialValue: T) {
  const [value, setValue] = useState(initialValue);

  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return [value, setValue, ref] as [
    T,
    React.Dispatch<React.SetStateAction<T>>,
    React.MutableRefObject<T>
  ];
}
